import React, { useState } from "react";

/**
 * File-drop zone with drag-over state. Parent controls onDrop handler.
 * @param {Object} props
 * @param {string} [props.hint]
 * @param {(files:FileList)=>void} [props.onFiles]
 */
export function FileDrop({ hint = "Drop file or click to attach", onFiles }) {
  const [drag, setDrag] = useState(false);
  return (
    <div
      className={`ds-file-drop ${drag ? "is-drag" : ""}`.trim()}
      onDragEnter={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        if (onFiles && e.dataTransfer?.files) onFiles(e.dataTransfer.files);
      }}
    >
      {drag ? "Release to attach" : hint}
    </div>
  );
}
